"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentenceRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const word_renderer_1 = require("./word-renderer");
exports.SentenceRenderer = (0, react_1.memo)(({ sentence, currentPlayTime, onSelect }) => {
    const wordIndex = (0, react_1.useMemo)(() => {
        if (currentPlayTime) {
            for (let i = sentence.words.length - 1; i >= 0; i--) {
                const word = sentence.words[i];
                if (currentPlayTime > word.audioOffset + word.audioDuration) {
                    return i + 1;
                }
            }
        }
        return 0;
    }, [currentPlayTime, sentence.words]);
    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: sentence.words.map((word, index) => {
            return ((0, jsx_runtime_1.jsx)(word_renderer_1.WordRenderer, { word: word, onSelect: onSelect, isInCurrentSentence: !!currentPlayTime, isInCurrentWord: wordIndex === index && !!currentPlayTime }, index));
        }) }));
});
exports.SentenceRenderer.displayName = "SentenceRenderer";
